module.exports = __webpack_public_path__ + "media/app/img/ubuntu-logo-ca537ac544bf1d5bfc4f96b7c0778361.png";